import Vue from 'vue'

Vue.mixin({
  data: function() {
    return {
      siteId: process.env.siteId
    }
  }
})
